<div class="inactivate-modal-backdrop" (click)="onCancel()">
  <div class="inactivate-modal-card" (click)="$event.stopPropagation()">
    <!-- Cabecera de advertencia -->
    <div class="modal-header-danger">
      <div class="danger-icon-badge">
        <span class="material-symbols-outlined">person_off</span>
      </div>
      <div>
        <h3 class="modal-title-danger">Inactivar Cuenta de Colaborador</h3>
        <p class="modal-subtitle-danger">
          Esta acción suspenderá inmediatamente el acceso operativo del colaborador a la plataforma ABAQ.
        </p>
      </div>
    </div>

    <!-- Ficha de detalles del colaborador -->
    <div class="target-details-box">
      <div class="detail-row">
        <span class="detail-label">Colaborador:</span>
        <span class="detail-value text-bold">{{ targetName }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Folio Oficial:</span>
        <span class="detail-folio-pill">{{ targetFolio }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Modalidad:</span>
        <span class="detail-value">
          {{ targetRole === 'student' ? 'Servicio Social (SS - 480 horas)' : 'Voluntariado General (VG)' }}
        </span>
      </div>
    </div>

    <!-- Guard de seguridad por tipeo de folio -->
    <div class="form-group-guard">
      <label class="guard-label" for="inputTypedFolio">
        Guard de Seguridad: Escribe exactamente <span class="folio-highlight">{{ targetFolio }}</span> para desbloquear la confirmación:
      </label>
      <div class="input-with-validation">
        <input
          id="inputTypedFolio"
          type="text"
          class="form-control folio-input"
          [class.is-valid]="isFolioValid"
          [class.is-invalid]="typedFolio.trim().length > 0 && !isFolioValid"
          placeholder="Escribe el folio aquí..."
          [(ngModel)]="typedFolio"
          autocomplete="off"
        />
        @if (isFolioValid) {
          <span class="validation-badge success">
            <span class="material-symbols-outlined text-sm">check_circle</span> Coincide
          </span>
        }
      </div>
      @if (typedFolio.trim().length > 0 && !isFolioValid) {
        <small class="error-hint">El folio tipeado no coincide exactamente.</small>
      }
    </div>

    <!-- Comentarios obligatorios a discreción del administrador -->
    <div class="form-group-comments">
      <label class="comments-label" for="textareaComments">
        Motivo Institucional / Observaciones de la Baja <span class="required-asterisk">*</span>:
      </label>
      <textarea
        id="textareaComments"
        class="form-control comments-textarea"
        rows="3"
        placeholder="Redacta la justificación formal de la baja administrativa (ej. retiro voluntario, baja acordada)..."
        [(ngModel)]="comments"
      ></textarea>
      <small class="comments-hint">
        Este comentario se registrará en la bitácora histórica y se notificará formalmente al colaborador vía correo institucional.
      </small>
    </div>

    @if (errorMessage) {
      <div class="alert-error-box">
        {{ errorMessage }}
      </div>
    }

    <!-- Botonera de acciones -->
    <div class="modal-footer-actions">
      <button
        type="button"
        class="btn-cancel"
        (click)="onCancel()"
        [disabled]="isSubmitting"
      >
        Cancelar
      </button>

      <button
        type="button"
        class="btn-confirm-danger"
        [disabled]="!canConfirm"
        (click)="onConfirm()"
      >
        @if (isSubmitting) {
          <span class="spinner-border spinner-border-sm me-2"></span>
          Procesando baja...
        } @else {
          <span class="material-symbols-outlined btn-icon">person_off</span>
          Inactivar Cuenta Definitivamente
        }
      </button>
    </div>
  </div>
</div>
